export default {
	none: 'none',
	formelement: 'procedure-form-element',
	procedure: 'procedure',
	toothchart: 'toothmap',
	radiograph: 'radiograph',
	treatmentsession: 'treatment-session',
	procedures: 'procedures',
	grades: 'grades',
	teachergrades: 'teacher-grades',
	students: 'students',
	competencytestpass: 'test',
	form: 'form',
	formscores: 'form-scores',
	absences: 'absences',
	attendance: 'attendance',
	allstudentsreport: 'allstudentsreport',
	treatmentsessionreflections: 'treatment-session-student-reflections',
	treatmentsessionreflectiontext: 'treatment-session-student-reflection-text',
	treatmentsessionfeedback: 'treatment-session-feedback',
	treatmentsessionteacherfeedback: 'treatment-session-teacher-feedback',
	thirdpartydata: 'third-party-data',
	learningoutcomemapping: 'learning-outcomes',
	learningoutcomemapped: 'learning-outcomes-mapped',
	timeline: 'timeline-student-reflections',

	other: 'other'
};
